import DebitSuccessModal from "components/layout/DebitSuccessModal";
import DirectDebitForm from "components/MI/DirectDebitForm";
import GenericDebit from "components/layout/DebitErrorModal";
import React, { useCallback, useMemo, useState } from "react";
import { Body, Container, Header } from "./styles";
import { banks } from "components/MI/DirectDebitForm/banks";
import { toast } from "react-toastify";
import { toggleNewUnitStep } from "store/actions/add-new-unit-actions";
import { useAddNewunit } from "pages/AddNewUnit/hooks/useAddNewUnit";
import { useDispatch, useSelector } from "react-redux";

const DirectDebit = (): JSX.Element => {
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );
  const dispatch = useDispatch();
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);

  const { setStep } = useAddNewunit();

  const handleSuccessSubmit = useCallback(() => {
    setOpenSuccessModal(true);
  }, [dispatch, toggleNewUnitStep, setOpenSuccessModal]);

  const handleSubmitErrorAction = useCallback(
    (err) => {
      if (err.response) {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          const { code } = err.response.data;
          if (err.response.status !== 401 && code !== "422.033") {
            toast.error(message);
          } else {
            setOpenErrorModal(true);
          }
        } else {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      } else {
        setOpenErrorModal(true);
      }
    },
    [setOpenErrorModal]
  );

  const handleSkipDirectDebit = useCallback(() => {
    setStep(5);
  }, []);

  const closeSuccessModal = useCallback(() => {
    setStep(5);
    setOpenSuccessModal(false);
  }, [dispatch, toggleNewUnitStep]);

  const message = useMemo(() => {
    if (selectedBank) {
      const mensagem = banks?.find(
        (bank) => bank?.code === selectedBank
      )?.mensagem;
      if (mensagem) {
        return mensagem;
      }
      return "";
    }
    return "";
  }, [selectedBank, banks]);

  return (
    <Container>
      <Header>
        <h1>Débito automático</h1>
      </Header>

      <Body>
        <DirectDebitForm
          unit={selectedUnit}
          // @ts-ignore
          setSelectedBank={setSelectedBank}
          handleSubmitErrorAction={handleSubmitErrorAction}
          handleSubmitAction={handleSuccessSubmit}
          handleCancelAction={handleSkipDirectDebit}
          cancelButtonText="Pular e concluir"
        />
      </Body>

      <DebitSuccessModal
        openModal={openSuccessModal}
        modalFunction={closeSuccessModal}
        text={message}
      />

      <GenericDebit
        openModal={openErrorModal}
        modalFunction={setOpenErrorModal}
      />
    </Container>
  );
};

export default DirectDebit;
